import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import LikeButton from "@/components/LikeButton";

const clamp2 = { display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" };

export const GalleryReportCard = ({ item, onView, showAuthor = true }) => {
  const navigate = useNavigate();
  const goAuthor = (e) => {
    e?.stopPropagation?.();
    if (item.author?.username) navigate(`/u/${encodeURIComponent(item.author.username)}`);
  };
  return (
    <div className="litra-card litra-card-hover p-4 flex flex-col" data-testid={`gallery-card-${item.id}`}>
      <button onClick={() => onView?.(item)} className="text-left flex-1" data-testid={`gallery-card-view-${item.id}`}>
        <div className="flex items-center justify-between gap-2">
          <span className="mono-chip text-[var(--bone-faint)] uppercase">{item.decode_type}</span>
          {item.has_full && <Badge className="gold-edge gold-text bg-transparent text-[10px]">Full</Badge>}
        </div>
        <div className="text-lg font-display font-semibold mt-1">{item.input_text}</div>
        {(item.root || item.seal) && (
          <div className="text-xs text-[var(--bone-faint)] mt-0.5">{item.root} → {item.seal}</div>
        )}
        {item.overview && <p className="text-sm text-[var(--bone-muted)] mt-2" style={clamp2}>{item.overview}</p>}
        <div className="mt-2 flex flex-wrap gap-1.5">
          {(item.top_letter_signals || []).slice(0, 3).map((s, i) => (
            <span key={i} className="mono-chip glass rounded-full px-2 py-0.5 text-[10px]">
              <span className="green-text">{s.letter}</span> {s.technical_name}
            </span>
          ))}
        </div>
        {item.archetype && <div className="mt-2 text-xs gold-text">{item.archetype}</div>}
      </button>
      <div className="mt-3 pt-3 border-t border-white/[0.06] flex items-center justify-between">
        {showAuthor ? (
          <button onClick={goAuthor} className="text-xs text-[var(--bone-faint)] hover:text-[var(--bone-muted)] transition-colors" data-testid={`gallery-author-${item.id}`}>
            by {item.author?.username || "Anonymous"}
          </button>
        ) : <span />}
        <LikeButton reportId={item.id} initialLiked={item.liked} initialCount={item.likes} />
      </div>
    </div>
  );
};

export default GalleryReportCard;
